import strFunc from "@/lib/lyg/string";
import DateFunc from '@/lib/lyg/date_func';
import CoolenMoveUrl from "@/pcomponents/common/content/coolen/study/func/move_url";

function DetailArrArea(props: any) {
  let myProps = {
    Style: {},
    select_study_use: null,
    section_info: {},
    study_list_arr: [],
    use_det_arr: [],
    ...props
  };
  let Style = myProps.Style;
  let select_study_use = myProps.select_study_use;
  let section_info = myProps.section_info;
  let study_list_arr = myProps.study_list_arr;
  let use_det_arr = myProps.use_det_arr;
  let row_study_list_arr: any = [];
  for (let i = 0; i < study_list_arr.length; i++) {
    let item = study_list_arr[i];
    if (item.a_section_seq == section_info.a_seq) {
      row_study_list_arr.push(item);
    }
  }

  let now_y_m_d_str = DateFunc.get_date_format(new Date(), "Y-m-d");
  let is_able_period = false;
  if (select_study_use.a_period_end_date>=now_y_m_d_str) {
    is_able_period = true;
  }

  const get_study_list_tags = () => {
    if (row_study_list_arr.length == 0) {
      return <div>학습이 없습니다.</div>;
    }
    let study_list_tags = row_study_list_arr.map((item: any, idx: number) => {
      let detail_use_info: any = null;
      for (let d_i = 0; d_i < use_det_arr.length; d_i++) {
        let tmp_detail_info = use_det_arr[d_i];
        if (tmp_detail_info["a_book_list_seq"] == item["a_seq"]) {
          detail_use_info = tmp_detail_info;
          break;
        }
      }
      let detail_success_per = 0;
      let detail_use_date_str = "";
      let detail_use_memo = "";
      let per_td_class_name = "";
      if (detail_use_info != null) {
        detail_success_per = detail_use_info["a_text_score"];
        detail_use_date_str = detail_use_info["a_reserve_date"];
        detail_use_memo = detail_use_info["a_memo"];
        if (detail_success_per >= 100) {
          per_td_class_name = "success_color";
        } else if (!strFunc.is_empty(detail_success_per)) {
          per_td_class_name = "ready_color";
        }
      }
      let row_title_str="";
      if(select_study_use&&select_study_use.textbook_title){
        row_title_str=select_study_use.textbook_title;
      }
      row_title_str+=" - "+item.a_title;
      return (
        <tr key={idx} className={Style.study_item_wrap}
          onClick={() => {
            if(is_able_period==false){
              alert("사용기간이 지났습니다. ~"+select_study_use.a_period_end_date);
              return false;
            }
            if (item.a_par_id == "contents_book") {
              CoolenMoveUrl.go_to_study_url({
                coolen_study_par_id: "mtextbook_list",
                detail_info: item,
                detail_use_info: detail_use_info,
                title:row_title_str,
              });
            } else if (item.a_par_id == "abc_study" && !strFunc.is_empty(item.a_par_seq)) {
              let study_list_pri_val = item["a_book_seq"] + "," + item["a_seq"];
              CoolenMoveUrl.go_to_url({
                coolen_study_par_id: "mtextbook_list",
                coolen_study_par_seq: study_list_pri_val,
                coolen_study_sort: "abc",
                study_is_save: "1",
                back_sort: "web_student",
                title:row_title_str,
              });
            } else if (item.a_par_id == "word_school") {
              let study_list_pri_val = item["a_book_seq"] + "," + item["a_seq"];
              CoolenMoveUrl.go_to_url({
                coolen_study_par_id: "mtextbook_list",
                coolen_study_par_seq: study_list_pri_val,
                coolen_study_sort: "word_school",
                study_is_save: "1",
                back_sort: "web_student",
                title:row_title_str,
              });
            } else {
              let study_list_pri_val = item["a_book_seq"] + "," + item["a_seq"];
              CoolenMoveUrl.go_to_url({
                coolen_study_par_id: "mtextbook_list",
                coolen_study_par_seq: study_list_pri_val,
                coolen_study_sort: "word2",
                study_is_save: "1",
                back_sort: "web_student",
                title:row_title_str,
              });
            }

          }}
        >
          <td className={Style.study_item_title}>
            {item.a_title}
          </td>
          <td className={per_td_class_name}>
            {detail_success_per}%
          </td>
          <td>
            {detail_use_date_str}
          </td>
          <td>
            {detail_use_memo}
          </td>
        </tr>
      );
    });
    return study_list_tags;
  };

  return (
    <div className={Style.study_detail_list}>
      <table>
        <tbody>
          {get_study_list_tags()}
        </tbody>
      </table>
    </div>
  );
};
export default DetailArrArea;